export const BASE_URL = '/users'

export const REDUCER_INDEX = 'users'

export const FAVORITES_VERSION = '1.0'

export enum FAVORITES_CATEGORIES {
  CONCEPT = 'concept',
  FORMULA = 'formula',
  ORDER = 'order',
}

export interface FAVORITES_CATEGORY_SCHEMA {
  [FAVORITES_CATEGORIES.CONCEPT]: {
    observations: string
    V?: string
  }
  [FAVORITES_CATEGORIES.FORMULA]: {
    administrationRoute: string
    concentration: string
    dosage: string
    frequency: string
    fullName: string
    idAdministrationRoute: string
    idPresentation: string
    ingredientId: string
    ingredientName: string
    name: string
    observations: string
    presentation: string
    quantity: number
    treatment: string
    V?: string
  }
  [FAVORITES_CATEGORIES.ORDER]: {
    amount: number
    code: string
    name: string
    observations: string
    procedureId: string
    V?: string
  }
}

export const FAVORITES_CATEGORY_SERIALIZE_KEYS = {
  [FAVORITES_CATEGORIES.CONCEPT]: ['observations'],
  [FAVORITES_CATEGORIES.FORMULA]: [
    'administrationRoute',
    'concentration',
    'dosage',
    'fullName',
    'idAdministrationRoute',
    'idPresentation',
    'ingredientId',
    'ingredientName',
    'name',
    'observations',
    'presentation',
  ],
  [FAVORITES_CATEGORIES.ORDER]: ['procedureId', 'observations'],
}

export const stringify = (obj: object, options?: { avoidKeys?: string[]; includeKeys?: string[] }) =>
  JSON.stringify(
    obj,
    Object.keys(obj)
      .filter((k: string) => !options?.includeKeys || options?.includeKeys.includes(k))
      .filter((k: string) => !options?.avoidKeys || !options?.avoidKeys.includes(k))
      .sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase())),
  )

export const getUniqueCode = async (str: string, algorithm: 'SHA-1' | 'SHA-256' | 'SHA-384' | 'SHA-512' = 'SHA-256') =>
  Array.from(new Uint8Array(await crypto.subtle.digest(algorithm, new TextEncoder().encode(str.toLowerCase()))))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
